import { BACKEND } from "../lib/backend";
import FitText from "./FitText";

// HTML/CSS preview of a slide (mirror of the server renderer).
// Used by the editor preview and the live SlideshowPlayer.
export function SlideCanvas({ slide, tier, bgColor, bgImage }) {
  const color = tier?.color || "#3B82F6";
  const innerBg = bgColor || "#0f0f11";
  const innerStyle = {
    background: innerBg,
    border: `min(1.2vh, 14px) solid ${color}`,
  };
  if (bgImage) {
    innerStyle.backgroundImage = `url(${BACKEND}${bgImage})`;
    innerStyle.backgroundSize = "cover";
    innerStyle.backgroundPosition = "center";
  }
  // Quick contrast check: choose light or dark text from bg luminance
  const h = (innerBg || "#0f0f11").replace("#", "");
  const c = h.length === 3 ? h.split("").map((x) => x + x).join("") : h;
  const r = parseInt(c.slice(0, 2), 16) || 0;
  const g = parseInt(c.slice(2, 4), 16) || 0;
  const b = parseInt(c.slice(4, 6), 16) || 0;
  const luma = 0.299 * r + 0.587 * g + 0.114 * b;
  const textColor = luma < 140 ? "text-white" : "text-zinc-900";
  const subtleColor = luma < 140 ? "text-zinc-300" : "text-zinc-700";
  // Visibility + scale controls
  const hideName = !!slide.hide_company_name;
  const hideCaption = !!slide.hide_caption;
  const rawScale = Number(slide.logo_scale);
  const logoScale = Number.isFinite(rawScale) && rawScale > 0
    ? Math.max(0.3, Math.min(3.0, rawScale))
    : 1.0;
  const hasName = !hideName && !!slide.company_name;
  const hasCaption = !hideCaption && !!slide.caption;
  const hasTextBelow = hasName || hasCaption;
  // Match the server's default footprint so the editor preview matches exports.
  const defMaxH = hasTextBelow ? 55 : 85;
  const defMaxW = hasTextBelow ? 70 : 85;
  const maxH = Math.min(95, defMaxH * logoScale);
  const maxW = Math.min(95, defMaxW * logoScale);
  return (
    <div className="absolute inset-0 grid place-items-center" style={{ background: "#08080a" }}>
      <div
        className="absolute inset-[2.2%] flex flex-col items-center justify-center text-center px-[5%] slide-enter"
        style={innerStyle}
      >
        {slide.image_url ? (
          <>
            <img
              alt=""
              src={`${BACKEND}${slide.image_url}`}
              className={`object-contain ${hasTextBelow ? "mb-[2%]" : ""}`}
              style={{ maxHeight: `${maxH}%`, maxWidth: `${maxW}%` }}
            />
            {hasName && (
              <FitText
                text={slide.company_name}
                className={`font-display font-bold ${textColor} text-2xl md:text-4xl tracking-tight leading-tight w-[90%]`}
                style={{ maxHeight: hasCaption ? "14%" : "22%" }}
              />
            )}
            {hasCaption && (
              <FitText
                text={slide.caption}
                className={`${subtleColor} text-sm md:text-base mt-2 leading-snug w-[80%]`}
                style={{ maxHeight: "20%" }}
              />
            )}
          </>
        ) : (
          <>
            {hasName && (
              <FitText
                text={slide.company_name}
                className={`font-display font-bold ${textColor} text-5xl md:text-7xl tracking-tight leading-tight w-[90%]`}
                style={{ maxHeight: hasCaption ? "55%" : "85%" }}
              />
            )}
            {hasCaption && (
              <FitText
                text={slide.caption}
                className={`${subtleColor} text-base md:text-xl mt-6 leading-snug w-[80%]`}
                style={{ maxHeight: "30%" }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
